import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {useSearchParams, Link} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatDate} from "../util/helpers";

// Insight list page for Admin
// Uses backend endpoint: GET /admin/v1/insight returning { contents, total }
// Mirrors the member list UX with search and pagination
export default function InsightMain() {
    const [pager, setPager] = useState();
    const [results, setResults] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();

    const page = parseInt(searchParams.get("page") || "1", 10);
    const size = parseInt(searchParams.get("size") || "30", 10);
    const searchType = searchParams.get("searchType") || "TITLE"; // TITLE | ID | MEMBER_ID
    const keyword = searchParams.get("keyword") || "";

    const requestData = () => {
        // Backend InsightController expects page starting from 0
        const params = {
            page: Math.max(0, page - 1),
            size,
        };

        // Pass through InsightCondition-like params via query string
        if (searchType && keyword) {
            if (searchType === "TITLE") params.title = keyword;
            if (searchType === "ID") params.id = keyword;
            if (searchType === "MEMBER_ID") params.memberId = keyword;
        }

        axios
                .get(`/admin/v1/insight`, {params})
                .then((res) => {
                    const data = res.data;
                    // data = { contents: [], total: number }
                    setResults(data.contents || []);
                    const totalElements = data.total || 0;
                    const totalPages = Math.ceil(totalElements / size);
                    setPager({
                        pageNumber: page - 1,
                        pageSize: size,
                        totalElements,
                        totalPages,
                        first: page <= 1,
                        last: page >= totalPages,
                        numberOfElements: (data.contents || []).length,
                        content: data.contents || [],
                    });
                });
    };

    const setPage = (value) => {
        searchParams.set("page", String(value));
        setSearchParams(searchParams);
    };

    const search = () => {
        setPage(1);
        requestData();
    };

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, size, searchType, keyword]);

    return (
            <div className="App">
                <div className="wrapper">
                    <div className="content-wrapper" style={{marginLeft: "0px"}}>
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-12">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item active">콘텐츠관리 > 인사이트 목록</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-tools" style={{marginTop: "40px"}}>
                                                <div className="form-group row" style={{float: "right"}}>

                                                    <label className="col-sm-auto col-form-label"
                                                           style={{marginLeft: "10px"}}>
                                                        검색
                                                    </label>

                                                    <select
                                                            className="form-control float-right"
                                                            style={{width: "140px", marginRight: "10px"}}
                                                            onChange={(e) => {
                                                                searchParams.set("page", "1");
                                                                searchParams.set("searchType", e.target.value);
                                                                setSearchParams(searchParams);
                                                            }}
                                                            value={searchType}
                                                    >
                                                        <option value="TITLE">제목</option>
                                                        <option value="ID">ID</option>
                                                        <option value="MEMBER_ID">회원ID</option>
                                                    </select>

                                                    <input
                                                            type="text"
                                                            className="form-control float-right"
                                                            style={{width: "220px", marginRight: "20px"}}
                                                            placeholder="검색어를 입력하세요"
                                                            value={keyword}
                                                            onChange={(e) => {
                                                                searchParams.set("page", "1");
                                                                searchParams.set("keyword", e.target.value);
                                                                setSearchParams(searchParams);
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter") {
                                                                    e.preventDefault();
                                                                    search();
                                                                }
                                                            }}
                                                    />

                                                    <button
                                                            type="submit"
                                                            className="btn btn-info float-right"
                                                            style={{width: "80px", marginRight: "10px"}}
                                                            onClick={search}
                                                    >
                                                        검색
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="card-body table-responsive p-0" style={{marginTop: "20px"}}>
                                                <table className="table table-hover text-nowrap"
                                                       style={{textAlign: "center"}}>
                                                    <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>작성자ID</th>
                                                        <th>제목</th>
                                                        <th>가격</th>
                                                        <th>거래유형</th>
                                                        <th>상담(분)</th>
                                                        <th>매칭수</th>
                                                        <th>생성일</th>
                                                        <th>상세보기</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {results &&
                                                            results.map((item) => (
                                                                    <tr key={item.id}>
                                                                        <td>{item.id}</td>
                                                                        <td>
                                                                            <a href={`/page/users/detail?userId=${item.memberId}`}
                                                                               target="_blank"
                                                                               rel="noopener noreferrer">
                                                                                {item.memberId}
                                                                            </a>
                                                                        </td>
                                                                        <td style={{textAlign: "center"}}>{item.title}</td>
                                                                        <td>{item.price?.toLocaleString?.() || item.price}</td>
                                                                        <td style={{color: item.tradeType === "SELL" ? "red" : "blue"}}>
                                                                            {item.tradeType === "SELL" ? "판매" : "구매"}
                                                                        </td>
                                                                        <td>{item.consultMinutes}</td>
                                                                        <td>{item.chatRoomCount}</td>
                                                                        <td>{formatDate(item.createdAt)}</td>
                                                                        <td>
                                                                            <button type="button" className="btn btn-outline-info">
                                                                                <Link to={`/page/insights/detail?id=${item.id}`}>보기</Link>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {pager && <Pagination pager={pager} setPage={setPage}/>}
                        </section>
                    </div>
                </div>
            </div>
    );
}
